import * as types from '../mutation-types'
import * as api from '@/api'

const HAS_HISTORY = window.history && window.history.pushState

// initial state
const state = {
  baseurl: process.env.BASEURL,
  lang: 'fr',
  url: null,
  copy: {
    no_results: {
      fr: 'Aucun K-Way ne correspond à cette recherche.',
      nl: 'Geen K-Way stemt met uw zoekopdracht overeen.',
      en: 'No K-Way matching your criteria.'
    },
    women: {
      fr: 'Femmes',
      nl: 'Dames',
      en: 'Women'
    },
    men: {
      fr: 'Hommes',
      nl: 'Heren',
      en: 'Men'
    },
    kids: {
      fr: 'Enfants',
      nl: 'Kinderen',
      en: 'Kids'
    },
    winter: {
      fr: 'Hiver',
      nl: 'Winter',
      en: 'Winter'
    },
    summer: {
      fr: 'Été',
      nl: 'Zomer',
      en: 'Summer'
    },
    discover: {
      fr: 'Découvrir',
      nl: 'Ontdek',
      en: 'Discover'
    },
    properties: {
      fr: 'Propriétés',
      nl: 'Eigenschappen',
      en: 'Properties'
    },
    colors: {
      fr: 'Couleurs',
      nl: 'Kleuren',
      en: 'Colors'
    },
    view_all: {
      fr: 'Voir tout',
      nl: 'Alles zien',
      en: 'View all'
    },
    kway_founds: {
      fr: 'K-Way trouvés',
      nl: 'K-Way gevonden',
      en: 'K-Way\'s found'
    },
    filter: {
      fr: 'Filtres',
      nl: 'Filters',
      en: 'Filters'
    },
    kway_found: {
      fr: 'K-Way trouvé',
      nl: 'K-Way gevonden',
      en: 'K-Way founnd'
    },
    close: {
      fr: 'Fermer',
      nl: 'Sluiten',
      en: 'Close'
    },
    season: {
      fr: 'Saison',
      nl: 'Seizoen',
      en: 'Season'
    },
    type: {
      fr: 'Type',
      nl: 'Type',
      en: 'Type'
    },
    reset: {
      fr: 'Réinitialiser',
      nl: 'Gereset',
      en: 'Reset'
    },
    available_colors: {
      fr: 'Couleurs disponibles',
      nl: 'Beschikbare kleuren',
      en: 'Available colors'
    },
    yes: {
      fr: 'Oui',
      nl: 'Ja',
      en: 'Yes'
    },
    no: {
      fr: 'Non',
      nl: 'Nee',
      en: 'No'
    },
    fit: {
      fr: 'Coupe',
      nl: 'Fitting',
      en: 'Fitting'
    },
    reversible: {
      fr: 'Réversible',
      nl: 'Omkeerbaar',
      en: 'Reversible'
    },
    sizes: {
      fr: 'Taille',
      nl: 'Maat',
      en: 'Size'
    },
    gender: {
      fr: 'Sexe',
      nl: 'Sex',
      en: 'Sex'
    },
    accessories: {
      fr: 'Accessoires',
      nl: 'Accessoires',
      en: 'Accessories'
    }
  }
}

// mutations
const mutations = {
  [types.SET_LANG] (state, lang) {
    state.lang = lang
    state.url = state.baseurl + state.lang
  },
  [types.SET_ROUTE] (state, path) {
    state.route = path

    if (window.location.search !== '') {
      state.route += window.location.search
    }

    if (HAS_HISTORY) {
      history.pushState(null, null, state.route)
    }
  }
}

const getters = {
  getUrl: function () {
    return state.url
  },
  getLang: function () {
    return state.lang
  },
  copy: (state) => (key) => {
    return state.copy[key][state.lang]
  }
}

const actions = {
  setLang: (store, lang) => {
    store.commit(types.SET_LANG, lang)
    store.commit(types.SET_LOCALE, {copyList: state.copy, lang})
    api.setUrl(state.url, lang)
  },
  setRoute: (store, payload) => {
    const path = state.route = '/' + state.lang + '/' + payload.segment1 + '/' + payload.segment2.replace(/é/gi, 'e').replace(/ /g, '-')
    store.commit(types.SET_ROUTE, path)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/locale.js